// src/templates/themes.js

export const THEMES = {
  // ================================================
  // MATRIMONIOS
  // ================================================
  'boda-clasica': {
    palette: {
      bg: 'linear-gradient(180deg,#fdfbf6 0%,#f5ebd9 100%)',
      primary: '#b8935a',
      dark: '#1f2937',
      muted: '#6b7280',
      card: '#ffffff',
      cardBorder: '#b8935a25',
      soft: '#f5ebd9',
    },
    fonts: { heading: "'Playfair Display', serif", body: "'Cormorant Garamond', serif", script: "'Cormorant Garamond', serif" },
    style: 'floral',       // decoración: floral | artdeco | boho | playful | confetti | cloud | star | garden | celestial | dark | elegant | minimal
    heroLayout: 'centered', // centered | stacked | split
    googleFonts: 'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;500;600&family=Playfair+Display:wght@400;700;900&display=swap',
  },

  'boda-elegante': {
    palette: {
      bg: 'linear-gradient(180deg,#0a0a15 0%,#1a1a30 100%)',
      primary: '#d4af37',
      dark: '#ffffff',
      muted: '#8b8b9a',
      card: '#15152a',
      cardBorder: '#d4af3730',
      soft: '#1a1a30',
    },
    fonts: { heading: "'Cinzel', serif", body: "'Cormorant Garamond', serif", script: "'Cormorant Garamond', serif" },
    style: 'artdeco',
    heroLayout: 'centered',
    googleFonts: 'https://fonts.googleapis.com/css2?family=Cinzel:wght@400;600;700&family=Cormorant+Garamond:ital,wght@0,400;0,600;1,400&display=swap',
  },

  'boda-boho': {
    palette: {
      bg: 'linear-gradient(180deg,#fbf5f0 0%,#f5e6d8 100%)',
      primary: '#c17f59',
      dark: '#4a3d32',
      muted: '#8a7968',
      card: '#ffffff',
      cardBorder: '#c17f5930',
      soft: '#f5e6d8',
    },
    fonts: { heading: "'Italiana', serif", body: "'Karla', sans-serif", script: "'Italiana', serif" },
    style: 'boho',
    heroLayout: 'stacked',
    googleFonts: 'https://fonts.googleapis.com/css2?family=Italiana&family=Karla:wght@400;500;600&display=swap',
  },

  // ================================================
  // CUMPLEAÑOS
  // ================================================
  'cumple-infantil': {
    palette: {
      bg: 'linear-gradient(135deg,#fff5f7 0%,#fff0e6 50%,#e6f4ff 100%)',
      primary: '#ff6b9d',
      secondary: '#ffd93d',
      tertiary: '#6bcbff',
      dark: '#2d2d5f',
      muted: '#6b7280',
      card: '#ffffff',
      cardBorder: '#ff6b9d40',
      soft: '#fff5f7',
    },
    fonts: { heading: "'Baloo 2', sans-serif", body: "'Fredoka', sans-serif", script: "'Baloo 2', sans-serif" },
    style: 'confetti',
    heroLayout: 'centered',
    googleFonts: 'https://fonts.googleapis.com/css2?family=Baloo+2:wght@500;700;800&family=Fredoka:wght@400;500;600&display=swap',
  },

  'cumple-tematico': {
    palette: {
      bg: 'linear-gradient(135deg,#1a0b2e 0%,#2d1b4e 50%,#16213e 100%)',
      primary: '#ff006e',
      secondary: '#ffbe0b',
      tertiary: '#8338ec',
      dark: '#ffffff',
      muted: '#a0a0b8',
      card: '#1a0b2ecc',
      cardBorder: '#ff006e40',
      soft: '#2d1b4e',
    },
    fonts: { heading: "'Bungee', cursive", body: "'Poppins', sans-serif", script: "'Bungee', cursive" },
    style: 'comic',
    heroLayout: 'centered',
    googleFonts: 'https://fonts.googleapis.com/css2?family=Bungee&family=Poppins:wght@400;500;600;700&display=swap',
  },

  'cumple-juvenil': {
    palette: {
      bg: 'linear-gradient(180deg,#0a0e1a 0%,#1a1f35 100%)',
      primary: '#00d9ff',
      secondary: '#ff00aa',
      dark: '#ffffff',
      muted: '#8b92a8',
      card: '#151929',
      cardBorder: '#00d9ff30',
      soft: '#1a1f35',
    },
    fonts: { heading: "'Archivo Black', sans-serif", body: "'Inter', sans-serif", script: "'Archivo Black', sans-serif" },
    style: 'urban',
    heroLayout: 'split',
    googleFonts: 'https://fonts.googleapis.com/css2?family=Archivo+Black&family=Inter:wght@400;500;600;700&display=swap',
  },

  // ================================================
  // BABY SHOWER
  // ================================================
  'baby-shower-azul': {
    palette: {
      bg: 'linear-gradient(180deg,#a5d8ff 0%,#d4ecff 30%,#e7f3ff 70%,#f0f8ff 100%)',
      primary: '#4a90d9',
      secondary: '#a5d8ff',
      dark: '#2c3e50',
      muted: '#6b7d94',
      card: '#ffffff',
      cardBorder: '#4a90d930',
      soft: '#e7f3ff',
    },
    fonts: { heading: "'Quicksand', sans-serif", body: "'Quicksand', sans-serif", script: "'Quicksand', sans-serif" },
    style: 'cloud',
    heroLayout: 'centered',
    googleFonts: 'https://fonts.googleapis.com/css2?family=Quicksand:wght@400;500;600;700&display=swap',
  },

  'baby-shower-rosa': {
    palette: {
      bg: 'linear-gradient(180deg,#ffe0ec 0%,#ffd4e5 30%,#fff0f6 70%,#fff8fb 100%)',
      primary: '#e94b8a',
      secondary: '#ffb3d1',
      dark: '#4a2540',
      muted: '#a87394',
      card: '#ffffff',
      cardBorder: '#e94b8a30',
      soft: '#fff0f6',
    },
    fonts: { heading: "'Comfortaa', cursive", body: "'Nunito', sans-serif", script: "'Comfortaa', cursive" },
    style: 'flower',
    heroLayout: 'centered',
    googleFonts: 'https://fonts.googleapis.com/css2?family=Comfortaa:wght@400;500;700&family=Nunito:wght@400;500;600&display=swap',
  },

  'baby-shower-neutro': {
    palette: {
      bg: 'linear-gradient(180deg,#f0f4f3 0%,#e5ebe8 100%)',
      primary: '#7ba38a',
      secondary: '#e5c185',
      dark: '#2f3e36',
      muted: '#7d8c85',
      card: '#ffffff',
      cardBorder: '#7ba38a30',
      soft: '#e5ebe8',
    },
    fonts: { heading: "'Josefin Sans', sans-serif", body: "'Jost', sans-serif", script: "'Josefin Sans', sans-serif" },
    style: 'minimal',
    heroLayout: 'split',
    googleFonts: 'https://fonts.googleapis.com/css2?family=Josefin+Sans:wght@400;500;600;700&family=Jost:wght@400;500;600&display=swap',
  },

  // ================================================
  // BAUTIZOS
  // ================================================
  'bautizo-dorado': {
    palette: {
      bg: 'linear-gradient(180deg,#fdf8ed 0%,#f5ecd9 100%)',
      primary: '#c8a961',
      dark: '#3a3a3a',
      muted: '#6b6b6b',
      card: '#ffffff',
      cardBorder: '#c8a96130',
      soft: '#f5ecd9',
    },
    fonts: { heading: "'Cinzel', serif", body: "'Cormorant Garamond', serif", script: "'Cormorant Garamond', serif" },
    style: 'celestial',
    heroLayout: 'centered',
    googleFonts: 'https://fonts.googleapis.com/css2?family=Cinzel:wght@400;600;700&family=Cormorant+Garamond:ital,wght@0,400;0,600;1,400&display=swap',
  },

  'bautizo-celestial': {
    palette: {
      bg: 'linear-gradient(180deg,#eaf3fb 0%,#d5e5f5 50%,#f0f6fc 100%)',
      primary: '#6b9ec9',
      secondary: '#c5b8dd',
      dark: '#2d3d52',
      muted: '#7087a3',
      card: '#ffffff',
      cardBorder: '#6b9ec930',
      soft: '#eaf3fb',
    },
    fonts: { heading: "'Cormorant Garamond', serif", body: "'Lato', sans-serif", script: "'Cormorant Garamond', serif" },
    style: 'star',
    heroLayout: 'centered',
    googleFonts: 'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;1,400&family=Lato:wght@400;500;700&display=swap',
  },

  'bautizo-jardin': {
    palette: {
      bg: 'linear-gradient(180deg,#f5f9f3 0%,#e8f0e3 100%)',
      primary: '#7a9d6b',
      secondary: '#d4c5a8',
      dark: '#3a4a32',
      muted: '#7d8a76',
      card: '#ffffff',
      cardBorder: '#7a9d6b30',
      soft: '#e8f0e3',
    },
    fonts: { heading: "'Cormorant Garamond', serif", body: "'Nunito Sans', sans-serif", script: "'Cormorant Garamond', serif" },
    style: 'garden',
    heroLayout: 'centered',
    googleFonts: 'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;1,400&family=Nunito+Sans:wght@400;500;600&display=swap',
  },

  // ================================================
  // GRADUACIONES
  // ================================================
  'graduacion-moderna': {
    palette: {
      bg: 'linear-gradient(180deg,#0f0f14 0%,#1a1a24 100%)',
      primary: '#ffb547',
      secondary: '#ff7a59',
      dark: '#ffffff',
      muted: '#8b8b9a',
      card: '#1a1a24',
      cardBorder: '#ffb54730',
      soft: '#1a1a24',
    },
    fonts: { heading: "'Space Grotesk', sans-serif", body: "'Inter', sans-serif", script: "'Space Grotesk', sans-serif" },
    style: 'urban',
    heroLayout: 'split',
    googleFonts: 'https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;500;600;700&family=Inter:wght@400;500;600&display=swap',
  },

  'graduacion-elegante': {
    palette: {
      bg: 'linear-gradient(180deg,#0a1628 0%,#0f2138 100%)',
      primary: '#c9a961',
      secondary: '#8f9bb0',
      dark: '#ffffff',
      muted: '#8b9ab0',
      card: '#0f2138',
      cardBorder: '#c9a96130',
      soft: '#0f2138',
    },
    fonts: { heading: "'Cinzel', serif", body: "'Cormorant Garamond', serif", script: "'Cinzel', serif" },
    style: 'elegant',
    heroLayout: 'centered',
    googleFonts: 'https://fonts.googleapis.com/css2?family=Cinzel:wght@400;600;700&family=Cormorant+Garamond:ital,wght@0,400;0,600;1,400&display=swap',
  },

  'graduacion-juvenil': {
    palette: {
      bg: 'linear-gradient(135deg,#fef6ff 0%,#fff0f5 50%,#f0f4ff 100%)',
      primary: '#a855f7',
      secondary: '#ec4899',
      tertiary: '#06b6d4',
      dark: '#1e1b4b',
      muted: '#6b7280',
      card: '#ffffff',
      cardBorder: '#a855f730',
      soft: '#f5f3ff',
    },
    fonts: { heading: "'Plus Jakarta Sans', sans-serif", body: "'Plus Jakarta Sans', sans-serif", script: "'Plus Jakarta Sans', sans-serif" },
    style: 'gradient',
    heroLayout: 'centered',
    googleFonts: 'https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap',
  },
};

export const DEFAULT_THEME = THEMES['boda-clasica'];